import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { closeOutline, mailOutline, openOutline, phonePortraitOutline } from "ionicons/icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowReportModal } from "../../../store/documentList";
import { selectFetchReportStatus } from "../../../store/documentList/selectors/selectFetchReportStatus";
import { selectReport } from "../../../store/documentList/selectors/selectReport";
import { selectShowReportModal } from "../../../store/documentList/selectors/selectShowReportModal";

export const ReportModal: React.FC = () => {
  const dispatch = useDispatch();
  const reportData = useSelector(selectReport);
  const fetchReportStatus = useSelector(selectFetchReportStatus);
  const showReportModal = useSelector(selectShowReportModal);

  return (
    <>
      <IonModal isOpen={showReportModal} onDidDismiss={() => dispatch(setShowReportModal(false))}>
        <IonHeader translucent>
          <IonToolbar>
            <IonTitle>Reporte pendientes</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => dispatch(setShowReportModal(false))}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent class="ion-padding">
          {fetchReportStatus === "pending" && (
            <p>Cargando reporte, esto puede tomar varios segundos...</p>
          )}
          {fetchReportStatus === "fulfilled" && (
            <IonList>
              {reportData.map((supervisorItem: any) => (
                <>
                  <IonItem>
                    <IonLabel>
                      <h3>Supervisor</h3>
                      <h2 style={{ fontWeight: 500 }}>{supervisorItem.name}</h2>
                      {supervisorItem.id && (
                        <h4 style={{ fontWeight: 500 }}>
                          <IonIcon icon={mailOutline} />
                          <IonText class="ion-margin-start">{supervisorItem.email || "--"}</IonText>

                          <IonIcon icon={phonePortraitOutline} class="ion-margin-start" />
                          <IonText class="ion-margin-start">
                            {supervisorItem.celular || "--"}
                          </IonText>
                        </h4>
                      )}
                    </IonLabel>
                  </IonItem>
                  <IonListHeader>
                    <h3>{supervisorItem.users.length} pendientes</h3>
                  </IonListHeader>
                  {supervisorItem.users.map((user: any, index: number) => (
                    <IonItem key={`item-${index}`} class="ion-margin-start" lines="none">
                      <IonLabel>
                        <h3>{user.name}</h3>
                      </IonLabel>
                      <IonButtons slot="end">
                        <IonButton
                          size="small"
                          fill="solid"
                          target="_BLANK"
                          color="primary"
                          href={`/app/rrhh/acuerdos/${user.document?.id}`}
                        >
                          <IonText>
                            <small>Ver acuerdo</small>
                          </IonText>
                          <IonIcon slot="end" icon={openOutline}></IonIcon>
                        </IonButton>
                      </IonButtons>
                    </IonItem>
                  ))}
                  <br />
                </>
              ))}
            </IonList>
          )}
        </IonContent>
      </IonModal>
    </>
  );
};
